(function () {
    'use strict';

    angular
        .module('webinar')
        .controller('WebinarBlockDatesController', WebinarBlockDatesController);

    WebinarBlockDatesController.$inject = ['$uibModal', 'WebinarService'];

    function WebinarBlockDatesController($uibModal, WebinarService) {
        var vm = this;

        /* Calendar functions */
        vm.addEvent             = addEvent;
        vm.deleteBlockDate      = deleteBlockDate;

        /* End Calendar functions */
        vm.calendar = {
            height: 450,
            editable: true,
            eventClick : deleteBlockDate,
            dayClick : function(date, jsEvent, view) {

                $uibModal.open({
                    templateUrl: 'templates/webinar/reports/blockdates/create/webinarBlockDateCreate.modal.html',
                    controller: 'WebinarBlockDateCreateController',
                    controllerAs:'webinarBlockDateCreate',
                    resolve:
                        {
                            locations : function () {
                                return vm.locations;
                            },
                            date : function () {
                                return date;
                            },
                            calendar : function () {
                                return vm.calendar;
                            }
                        }
                });

            },
            events : []
        };

        function addEvent(data) {
            vm.date = new Date(data.start.replace(/-/g,"/"));
            vm.calendar.events.splice(data.id,0,{
                id : data.id,
                title: data.reason,
                start: vm.date,
                date : data.start,
                allDay: true,
                locations: data.locations,
                className: ['openSesame']
            });
        }

        function deleteBlockDate(event) {

            $uibModal.open({
                templateUrl: 'templates/webinar/reports/blockdates/update/webinarBlockDateUpdate.modal.html',
                controller: 'WebinarBlockDateUpdateController',
                controllerAs:'webinarBlockDateUpdate',
                resolve:
                    {
                        locations : function () {
                            return vm.locations;
                        },
                        event : function () {
                            return event;
                        },
                        calendar : function () {
                            return vm.calendar;
                        }
                    }
            });
        }

        function getBlockedDates () {
            vm.calendar.events = [];
            WebinarService.getBlockedDates().then(function(response){
                angular.forEach(response.data,function(value){
                    vm.addEvent(value);
                });
            });
        }

        function getWebinarLocations () {
            WebinarService.getWebinarLocations().then(function(response){
                vm.locations = response.data;
            });
        }

        function activate() {
            getBlockedDates();
            getWebinarLocations();
        }

        activate();
    }

})();